import { EntitiesStatus,License, LicenseFormatted } from 'common/types/Entities';
import { dateToFrontEndFormat } from 'common/utils/dateHelpers';
import { getActiveStatus, getInactiveStatus } from 'common/utils/userMembershipColumnsHelper';

import { APISuiteGetResponse } from '../ApplicationSuites/ApplicationSuitesApiTypeDefs';
import { APITenantGetResponse } from '../Tenants/TenantApiTypeDefs';

import { APILicenseGetResponse } from './LicenseApiTypeDef';

export const _isLicenseActive = (startDate: string, endDate?: string): EntitiesStatus => {
    const convertedStartDate = new Date(startDate);
    const convertedEndDate = endDate ? new Date(endDate) : null;
    const today = new Date();
    let isActive = false;
    if (convertedEndDate) {
        isActive = convertedEndDate > today && convertedStartDate < today;
    } else {
        isActive = convertedStartDate < today;
    }

    return isActive ? getActiveStatus() : getInactiveStatus();
};

export const _formatLicenseResponse = (rows: License[]) => {
    return rows.map(item => {
        const formatted: LicenseFormatted = {
            ...item,
            id: item.id,
            companyKey: item.companyKey,
            billingSystemName: item.billingSystemName,
            billingRecord: item.billingRecord,
            status: _isLicenseActive(item.startDate, item.endDate),
            startDate: dateToFrontEndFormat(item.startDate),
            endDate: item.endDate ? dateToFrontEndFormat(item.endDate) : '',
            licenseAutoRenewal: !item.endDate,
            name: item.billingSystemName + ' - ' + item.billingRecord
        };
        return formatted;
    });
};

export const _formatLicenseDetailsResponse = (
    appSuite: APISuiteGetResponse,
    tenant: APITenantGetResponse,
    license: APILicenseGetResponse
) => {
    return  {
        applicationSuiteId: appSuite.data.id,
        applicationSuiteName: appSuite.data.name,
        tenantId: tenant.data.id,
        tenantName: tenant.data.name,
        tenantRequiresLicense: tenant.data.isLicenseRequired,
        id: license.data.id,
        name: license.data.billingRecord ?? '',
        companyKey: license.data.companyKey,
        billingSystemName: license.data.billingSystemName,
        billingRecord: license.data.billingRecord,
        status: _isLicenseActive(license.data.startDate, license.data.endDate),
        licenseAutoRenewal: !license.data.endDate,
        startDate: dateToFrontEndFormat(license.data.startDate),
        endDate: license.data.endDate? dateToFrontEndFormat(license.data.endDate) : 'None',
        note: license.data.note,
        isLicenseRequired: tenant.data.isLicenseRequired,
    };
};
